<div class="container-sm">
  <div class="row">
    @for (item of data.teasers; track $index) {
      <mb-card
        (click)="openCardMedia(item)"
        class="col-12 col-md-4"
        alignContent="top"
        [data]="item"
        [layout]="layout"
        [actions]="item.actions"
      >
        <figure>
          <mb-media [media]="item.media" [hoverplay]="true"></mb-media>
        </figure>
      </mb-card>
    }
  </div>
</div>
